import { useState } from 'react';
import { FractionIcon, CloseIcon, DivideIcon } from '@/utils/icons';
import { BlockMath } from 'react-katex';
import s from './index.module.css';
import commonStyle from '../common.module.css'
import classNames from 'classnames';
import { ButtonDel } from '@UI/Button';
import { MULTIPLICATION, FRACTION, SQUAREROOT, DIVIDE, ADDITION, SUBTRACTION, NTHROOT, MIXEDFRACTION } from '../../constants';

export const Menu = ({add, menuToggle}) => {

    return (
        <div className={s.menuWrapper}>
            <span className={s.title}>Выберите элементы конструктора</span>
            <ButtonDel 
                onClick={menuToggle}
                className={s.closeMenu}
            />
            <button type="button" className={classNames(s.item, s.mixedFraction)} onClick={() => add({type: MIXEDFRACTION})} title='Смешанная дробь'>
                <span>x</span>
                <FractionIcon />
            </button>
            <button type="button" className={s.item} onClick={() => add({type: FRACTION})} title='Дробь'>
                <FractionIcon />
            </button>
            <button 
                type="button"
                className={classNames(commonStyle.blockMath, s.item)} 
                onClick={() => add({type: SQUAREROOT})} 
                title='Корень квадратный'>
                <BlockMath>{"\\sqrt{x}"}</BlockMath>
            </button>
            <button 
                type="button"
                className={classNames(commonStyle.blockMath, s.item, s.itemNthRoot)} 
                onClick={() => add({type: NTHROOT})} 
                title='Корень степени n'>
                <span className={s.degree}>n</span>
                <BlockMath>{"\\sqrt{x}"}</BlockMath>
            </button>
            <button type="button" className={classNames(s.item, s.multiplication)} onClick={() => add({type: MULTIPLICATION})} title='Умножить'>
                ×
            </button>
            <button type="button" className={classNames(s.item, s.divide)} onClick={() => add({type: DIVIDE})} title='Делить'>
                ÷
            </button>
            <button type="button" className={classNames(s.item, s.addition)} onClick={() => add({type: ADDITION})} title='Сложить'>
                +
            </button>
            <button type="button" className={classNames(s.item, s.subtraction)} onClick={() => add({type: SUBTRACTION})} title='Вычесть'>
                -
            </button>
        </div>
    );
};